import { DISCORD_URL } from 'lib/constants'

export const STUDIO_NAVIGATION = [
  { anchor: '#main', text: 'Home', options: { sx: { color: 'white' } } },
  { anchor: '#games', text: 'Games', options: { sx: { color: 'white' } } },
  { anchor: DISCORD_URL, text: 'Join community', options: { variant: 'contained' } },
]
